import { convert } from 'html-to-text'
import { formatText, formatTextPdf } from './formatText'
// import html2pdf from "html2pdf.js";

function createDoc(data) {
    var dd = {
        content: [
            {
                alignment: 'justify',
                columns: [
                    {
                        image: 'rx',
                        height: 40,
                        width: 100
                    }
                ]
            },
            {
                text: '_______________________________________________________________________________________________',
            },
            {
                columns: [
                    {
                        text: [
                            { text: data?.providername ? 'Transcript Recorded By: ' : 'File Name : ', bold: true },
                            { text: `${data?.providername ? data?.providername : data.file}\n` },
                            { text: 'Date And Time: ', bold: true },
                            { text: `${data.time}\n` },
                        ]
                    },
                ],
                margin: [0, 0, 0, 10]
            },
            {
                text: 'TRANSCRIPT',
                bold: true,
                margin: [0, 10, 0, 10]
            },
            data.messages,
            data.includeSummary ? {
                text: 'SUMMARY',
                bold: true,
                margin: [0, 10, 0, 10]
            } : "",
            data.includeSummary ? convert(formatText(data.summarizedTranscript)) : ""
        ],
        images: {
            rx: data.url,
        },
        styles: {
            header: {
                fontSize: 25,
                bold: true
            },
        }

    }

    return dd;
}

const generatePDF = (transcriptDetails) => {
    const { providerName, patientName, createdAt, messages, includeSummary, summarizedTranscription } = transcriptDetails;

    // Create a temporary div for HTML content
    const content = document.createElement("div");
    content.style.padding = "20px";
    content.style.fontFamily = "Arial, sans-serif";
    content.style.maxWidth = "600px";
    content.style.margin = "auto";

    content.innerHTML = `
        <h2 style="text-align: center;">Transcript Report</h2>
        <hr />
        <p><strong>Provider Name:</strong> ${providerName || "N/A"}</p>
        <p><strong>Patient Name:</strong> ${patientName || "N/A"}</p>
        <p><strong>Date & Time:</strong> ${createdAt}</p>
        <p><strong>Transcript:</strong> ${messages}</p>

        ${includeSummary ? `
            <hr />
            <h3>Summary</h3>
            <p>${summarizedTranscription || "No Summary Available"}</p>
        ` : ""}
    `;

    // Generate PDF and open in a new tab
    // html2pdf()
    //     .from(content)
    //     .toPdf()
    //     .get("pdf")
    //     .then((pdf) => {
    //         const pdfBlob = pdf.output("blob");
    //         const pdfUrl = URL.createObjectURL(pdfBlob);

    //         // Open the PDF in a new tab
    //         window.open(pdfUrl, "_blank");

    //         // Auto-download the PDF
    //         const a = document.createElement("a");
    //         a.href = pdfUrl;
    //         a.download = "transcript.pdf";
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);
    //     });
};

export { createDoc, generatePDF }